import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wrench, Construction } from "lucide-react";
import { apiFetch } from "@/lib/api";
import { PageTitle, PageSubtitle, Loader, Card } from "@/components/common";

export default function ServicesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    apiFetch("/services").then(setItems).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4">
      <PageTitle>Servizi per mezzi pesanti</PageTitle>
      <PageSubtitle>Trova rapidamente l'assistenza giusta lungo il percorso.</PageSubtitle>
      <Link to="/service-requests" data-testid="services-request-link" className="inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2.5 text-sm font-extrabold text-primary-foreground">
        <Wrench className="h-4 w-4" /> Richiedi un servizio
      </Link>
      <div className="flex items-center gap-3 rounded-2xl bg-primary p-4 text-primary-foreground">
        <Construction className="h-7 w-7" />
        <div>
          <p className="font-extrabold">Una rete per il tuo lavoro</p>
          <p className="text-xs text-primary-foreground/85">Le categorie sono pronte per accogliere fornitori verificati.</p>
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {items.map((it) => (
            <Link key={it.id} to={`/services/${it.category}`} state={{ name: it.name }} data-testid={`service-category-${it.category}`}>
              <Card className="flex min-h-[130px] flex-col justify-between hover:shadow-md">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-secondary">
                  <Wrench className="h-5 w-5 text-primary" />
                </span>
                <div>
                  <p className="text-[13px] font-extrabold leading-snug text-foreground">{it.name}</p>
                  <p className="text-[11px] text-muted-foreground">
                    {it.providers ? `${it.providers} ${it.providers === 1 ? "fornitore" : "fornitori"}` : "Scopri i servizi"}
                  </p>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
